<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-center">VIDEO & PHOTO EDITING</h1>
      </div>

      <div v-for="(game, gameIndex) in games" :key="gameIndex" class="animation col-xs-12">
        <!-- Carousel container -->
        <div :id="`my-pics${gameIndex}`" class="carousel slide" data-ride="carousel">
          <!-- Indicators -->
          <ol v-if="game.totalImages > 1" class="carousel-indicators">
            <li v-for="(number, imageIndex) in game.totalImages" :key="imageIndex" :data-target="`#my-pics${gameIndex}`"
              :data-slide-to="imageIndex" :class="{ active: imageIndex == 0 }"></li>
          </ol>

          <!-- Content -->
          <div class="carousel-inner" role="listbox">
            <!-- Slides -->
            <div v-for="(number, imageIndex) in game.totalImages" :key="imageIndex" class="item"
              :class="{ active: imageIndex == 0 }">
              <img :src="require(`@/assets/gallery/video-photo/${game.imageFolder}/${number}.png`)" alt="" />
            </div>
          </div>

          <!-- Previous/Next controls -->
          <template v-if="game.totalImages > 1">
            <a class="left carousel-control" :href="`#my-pics${gameIndex}`" role="button" data-slide="prev">
              <span class="icon-prev" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="right carousel-control" :href="`#my-pics${gameIndex}`" role="button" data-slide="next">
              <span class="icon-next" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </template>
        </div>
        <div class="desc">
          <h2>{{ game.title }}</h2>
          <p v-html="game.desc"></p>
          <a v-if="game.downloadLink" class="btn btn-default download-btn" :href="game.downloadLink" target="_blank"
            role="button">Store page</a>
        </div>
      </div>

      <div class="animation col-xs-12">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe 
            class="embed-responsive-item" 
            src="https://www.youtube.com/embed/HtxEN1IVXnY"
            title="LOL car"
            allow="encrypted-media; web-share" 
            allowfullscreen
          ></iframe>
        </div>
        <div class="desc">
          <h2>LOL car</h2>
          <p>
            This is a video that I edited along with all the other videos from this youtube channel:
            <a style="color:#FF007F" href="https://www.youtube.com/channel/UCgzFw2mqQaYReI9vIaanJGw/videos"
              target="_blank"><i>2 Cute Little Girls</i></a>.
            It's about two little girls playing and doing fun stuff.
            I also made the channel's banner and profile picture.
            <br><br>
            Edited with Filmora and Photoshop.
          </p>
        </div>
      </div>

      <div class="animation col-xs-12">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe 
            class="embed-responsive-item" 
            src="https://www.youtube.com/embed/qb2I-SbteXI"
            allow="encrypted-media; web-share" 
            allowfullscreen
            ></iframe>
        </div>
        <div class="desc">
          <h2>MONTH OF THE BOOK 2021 - RAINBOW OF WORDS</h2>
          <p>
            This is a video in which children recite verses by famous Balkan poets and writers.
            I edited this along with three other videos on this youtube channel
            <a style="color:rgb(255, 253, 109)" href="https://www.youtube.com/channel/UCKl5f675bMGckH5CK9RF93w"
              target="_blank"><i>OJU
                Partizanski dom Sandevo</i></a>:<br>
            - <a style="color:rgb(255, 253, 109)" href="https://www.youtube.com/watch?v=00DPKAG44HI"
              target="_blank"><i>Concert in honor
                of Aleksandar Urdarevski - online</i></a><br>
            - <a style="color:rgb(255, 253, 109)" href="https://www.youtube.com/watch?v=yAsjKvouzUk" target="_blank"><i>Book
                Month 2021 -
                We travel, we dream, we make friends with the book</i></a><br>
            - <a style="color:rgb(255, 253, 109)" href="https://www.youtube.com/watch?v=OjGeeKHo_sA"
              target="_blank"><i>Concert in honor
                of Aleksandar Urdarevski - online - 2022</i></a>
            <br><br>
            Edited with Filmora and Photoshop.
          </p>
        </div>
      </div>

      <div class="animation col-xs-12">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe 
            class="embed-responsive-item" 
            src="https://www.youtube.com/embed/ATCnFxSDwWE"
            allow="encrypted-media; web-share" 
            allowfullscreen
            ></iframe>
        </div>
        <div class="desc">
          <h2>Gjorgji Cvetkovski, Highlights VOL 3</h2>
          <p>
            This is a highlight video about a young and talented basketball player named Gjorgji Cvetkovski. Youtube
            channel: <a style="color:rgb(158, 158, 255)" href="https://www.youtube.com/channel/UC0-3ihul8HFG51EPi94AJuw"
              target="_blank"><i>Gjorgji Cvetkovski - Highlights</i></a>.
            Other videos on this youtube channel edited by me:
            <br>- <a style="color:rgb(158, 158, 255)" href="https://www.youtube.com/watch?v=aY1SSj1FSOo" target="_blank"><i>Gjorgji
                Cvetkovski, Highlights VOL 4</i></a>
            <br>- <a style="color:rgb(158, 158, 255)" href="https://youtu.be/uto_smlZoj0" target="_blank"><i>Gjorgji Cvetkovski, (The
                Best of) Highlights (21/22), VOL 2</i></a>
            <br>- <a style="color:rgb(158, 158, 255)" href="https://youtu.be/U0LVw1B0ryg" target="_blank"><i>Gjorgji Cvetkovski
                Highlights (21/22), VOL 1</i></a>
            <br><br>
            Edited with Filmora and Photoshop.
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  //Slide show (bootstrap 3 carousel) link:
  //https://www.quackit.com/bootstrap/bootstrap_3/tutorial/bootstrap_carousel.cfm
  data() {
    return {
      games: [
        {
          title: 'PHOTOSHOP PROJECTS',
          desc:
            ``,
          imageFolder: 'photoshop',
          totalImages: 4,
          downloadLink: null,
        },
      ]
    }
  }
}
</script>

<style>
/* Global CSS outside the scoped attribute */
:root {
  --video-photo-primary-color: darkred;
  --video-photo-secondary-color:darkred;
}
</style>

<style scoped>
/* Scoped CSS for your component */
.container {
  color: white;
  margin-bottom: 50px;
  padding: 20px;
}

h1 {
  /*text-shadow: 0px 0px 2px crimson;*/
  margin-bottom: 40px;
  color: rgb(193, 0, 0);
  /* Using the primary color variable */
}

p {
  margin-top: 5px;
  text-align: justify;
  font-size: 18px;
}

.animation {
  background-color: var(--video-photo-secondary-color);
  /* Using the secondary color variable */
  border: 1px solid var(--video-photo-primary-color);
  /* Using the primary color variable */
  border-radius: 4px;
  box-shadow: 0px 0px 5px var(--video-photo-primary-color);
  /* Using the primary color variable */
  padding: 1px;
  margin-bottom: 70px;
}

.desc {
  margin: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border: 2px solid var(--video-photo-primary-color);
  /* Using the primary color variable */
  border-radius: 4px;
}

.desc h2 {
  margin-top: 10px;
}

.download-btn {
  background-color: var(--video-photo-primary-color);
  /* Using the primary color variable */
  border: 2px solid white;
  border-radius: 4px;
  box-shadow: 0px 0px 5px white;
  margin-bottom: 10px;
  color: white;
  font-size: 16px;
}

.download-btn:hover {
  background-color: white;
  color: var(--video-photo-primary-color);
  /* Using the primary color variable */
  border: 2px solid var(--video-photo-primary-color);
  /* Using the primary color variable */
}

@media screen and (min-width: 992px) {
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
}

section {
  /*background-color: #111845;*/
  min-height: 100vh;
}</style>
